import React, {Component, useState, useRef, useEffect} from 'react';
import {connectGeoSearch} from 'react-instantsearch-dom';

import styled from 'styled-components'

import GoogleMapReact from "google-map-react";
import useSupercluster from "use-supercluster";

import MapProjectView from './MapProjectView';
import MapProjectUnclaimedView from './MapProjectUnclaimedView';

import MarkerLightFrame from './markerLightFrame.svg';
import MarkerMassTimber from './markerMassTimber.svg';
//import MarkerMassTimber from './markers/full-normal-mt.svg';

import MarkerMassTimberHover from './markerMassTimberHover.svg';
import MarkerLightFrameHover from './markerLightFrameHover.svg';

import MarkerMastTimberUnclaimed from './markerMastTimberUnclaimed.svg';
import MarkerMastTimberUnclaimedHover from './markerMastTimberUnclaimedHover.svg';

import MarkerIcon from './MarkerIcon';
import Marker from './Marker';

import ProjectHelpIcon from './projectHelpIcon.svg';
import ProjectLinkIcon from './projectLinkIcon.svg';

import "./styles.css";
import {useTranslation} from "react-i18next";

//const Marker = ({ children }) => children;
const ClusterMarker = ({children}) => children;

const KEY_MAPZOOM = 'MAPZOOM';

const ProjectHelpButton = styled.button`
    width: auto;
    border: none;
    height: 40px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #e7b940;
    padding: 12px 5px 12px 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    position: absolute;
    left: 0%;
    bottom: 5%;
    cursor: pointer;
    font-family: Open Sans, sans-serif;;
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: left;
    color: #2c271c;
    z-index: 99;
    border-top: solid 2px #fff;
    border-bottom: solid 2px #fff;
    border-right: solid 2px #fff;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;

    &:hover {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        border-top: solid 2px #5b7e2d;
        border-bottom: solid 2px #5b7e2d;
        border-right: solid 2px #5b7e2d;
    }
`;

const GeoSearch = ({
                       hits,
                       position,
                       currentRefinement,
                       isRefinedWithMap,
                       refine,
                       createURL,
                       onMarkerHover,
                       stateSearchFilter,
                   }) => {

    const mapRef = useRef();
    const {t, i18n} = useTranslation();

    //console.log('map-currentRefinement', currentRefinement);

    const [bounds, setBounds] = useState(null);
    const [zoom, setZoom] = useState(null);
    const [selectedProject, setSelectedProject] = useState(null);
    const [selectedUnclaimedProject, setSelectedUnclaimedProject] = useState(null);

    const [mlat, setMlat] = useState(null);
    const [mlng, setMlng] = useState(null);
    const reg = new RegExp("^-?([1-8]?[1-9]|[1-9]0)\.{1}\d{1,6}");

    let initMapLocation = () => {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        console.log('urlParams', urlParams.has('utm_campaign'));

        if (typeof currentRefinement !== 'undefined' && typeof currentRefinement.southWest !== 'undefined') {
            var center_lat = (currentRefinement.southWest.lat + currentRefinement.northEast.lat) / 2; // = 55.043348151638
            console.log("center_lat=" + center_lat);
            var center_lng = (currentRefinement.southWest.lng + currentRefinement.northEast.lng) / 2; // = -1.991765383125
            console.log("center_lng=" + center_lng);
            setMlat(center_lat);
            setMlng(center_lng);
            const savedZoomState = localStorage.getItem(KEY_MAPZOOM);
            if (savedZoomState && typeof savedZoomState !== 'undefined') {
                console.log('savedZoomState', savedZoomState);
                console.log('urlParamsZoom', urlParams.has('zoom'));
                console.log('urlParamsZoomValue', parseInt(urlParams.get('zoom')));
                if (urlParams.has('zoom')) {
                    setZoom(parseInt(urlParams.get('zoom')));
                } else {
                    setZoom(parseInt(savedZoomState));
                }
            } else {
                setZoom(4.5);
            }
        } else if (window.location_city_lat) {
            console.log('window.location_city_lat', window.location_city_lat);
            console.log('window.location_city_lng', window.location_city_lng);
            setMlat(window.location_city_lat);
            setMlng(window.location_city_lng);
            setZoom(10);
            console.log('mlat', mlat);
        } else {

            // default zoom if in canada
            if (window.win_canada_zoom === 'True') {
                console.log('canada zoom');
                var center_lat = (35.99162629077149 + 74.83209074536012) / 2; // = 55.043348151638
                console.log("center_lat=" + center_lat);
                var center_lng = (-150.19355900379833 + -48.152543378798356) / 2; // = -1.991765383125
                console.log("center_lng=" + center_lng);
                //center_lat=55.411858518065806
                //center_lng=-99.17305119129834
                setMlat(55.411858518065806);
                setMlng(-100);
            } else {
                console.log('usa zoom');
                setMlat(41.5);
                setMlng(-100);
            }

            if (urlParams.has('zoom')) {
                console.log('zoom', urlParams.get('zoom'));
                setZoom(parseInt(urlParams.get('zoom')));
            } else {
                console.log('zoom', 4.5);
                setZoom(4.25);
            }


        }
    }


    let autocomplete;


    let initAutocomplete = () => {
        try {
            autocomplete = new window.google.maps.places.Autocomplete(
                document.getElementById('field-address'), {types: ['(regions)']});
            autocomplete.setFields(['address_component', 'geometry']);
            autocomplete.addListener('place_changed', fillInAddress
            );
        } catch (e) {
            console.log('window.google.maps.places.Autocomplete', e);
        }
        console.log('autocomplete', autocomplete);
    }

    let fillInAddress = () => {
        // Get the place details from the autocomplete object.
        let inputValue = document.getElementById('field-address').value;

        if (inputValue === '') {
            stateSearchFilter(null);
            mapRef.current.setZoom(4);
            console.log('no place');
            return true;
        }

        let place = autocomplete.getPlace();
        let place_lat;
        let place_lng;


        console.log('place', place);


        place_lat = place.geometry.location.lat();
        place_lng = place.geometry.location.lng();

        let is_city_zoom = place.address_components.some(a => {
            return a.types.includes('locality');
        });

        let zoom_level = is_city_zoom ? 10 : 6;

        console.log('is_city_zoom', is_city_zoom);
        console.log('zoom_level', zoom_level);

        if (!is_city_zoom) {
            let stateLocationFilter = place.address_components[0].short_name;
            let countryLocationFilter = place.address_components[0].types.includes('country') ? 'location_country' : 'location_state';


            for (let i = 0; i < place.address_components.length; i++) {
                if (place.address_components[i].types[0].toString() === 'country') {
                    if (countryLocationFilter === 'location_country') {
                        stateLocationFilter = place.address_components[i].long_name;
                    }
                }
            }

            let locationFilter = {
                name: stateLocationFilter,
                type: countryLocationFilter
            }

            console.log('countryLocationFilter', countryLocationFilter);
            console.log('locationFilter', locationFilter);

            stateSearchFilter(locationFilter);
        } else {
            stateSearchFilter(null);
        }


        setBounds([
            place.geometry.viewport.getSouthWest().lng(),
            place.geometry.viewport.getNorthEast().lat(),
            place.geometry.viewport.getNorthEast().lng(),
            place.geometry.viewport.getSouthWest().lat()
        ]);

        let pt = new window.google.maps.LatLng(place_lat, place_lng);
        mapRef.current.setCenter(pt);
        mapRef.current.setZoom(zoom_level);

        //let fitBounds = new window.google.maps.LatLngBounds(place.geometry.viewport.getSouthWest(),place.geometry.viewport.getSouthWest());

        //mapRef.current.fitBounds(fitBounds);
        refine({
            northEast: {
                lat: place.geometry.viewport.getNorthEast().lat(),
                lng: place.geometry.viewport.getNorthEast().lng()
            },
            southWest: {
                lat: place.geometry.viewport.getSouthWest().lat(),
                lng: place.geometry.viewport.getSouthWest().lng()
            },
        });

    }

    const _distanceToMouse = (markerPos, mousePos, markerProps) => {
        const x = markerPos.x;
        // because of marker non symmetric,
        // we transform it central point to measure distance from marker circle center
        // you can change distance function to any other distance measure
        const y = markerPos.y;

        // and i want that hover probability on markers with text === 'A' be greater than others
        // so i tweak distance function (for example it's more likely to me that user click on 'A' marker)
        // another way is to decrease distance for 'A' marker
        // this is really visible on small zoom values or if there are a lot of markers on the map
        const distanceKoef = 1;

        //const distance = distanceKoef * Math.sqrt((x - mousePos.x) * (x - mousePos.x) + (y - mousePos.y) * (y - mousePos.y));
        let distance = Math.sqrt((x - mousePos.x) * (x - mousePos.x) + (y - mousePos.y) * (y - mousePos.y));

        const savedZoomState = localStorage.getItem(KEY_MAPZOOM);
        if (savedZoomState && typeof savedZoomState !== 'undefined') {
            if (savedZoomState < 9) {
                if (markerProps.projectUnclaimed === true) {
                    distance = distance + 12;
                }
            }
        }

        //console.log('distance', distance, markerProps);
        //console.log('markerProps', markerProps);

        // it's just a simple example, you can tweak distance function as you wish
        return distance;
    }

    /*let geolocate = () => {
      console.log('geolocate');
      if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
              var geolocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
              };
              var circle = new window.google.maps.Circle(
                  {center: geolocation, radius: position.coords.accuracy});
              autocomplete.setBounds(circle.getBounds());
          });
      }
  }*/


    const points = hits.map(item => ({
        type: "Feature",
        id: item.objectID,
        properties: {
            cluster: false,
            id: item.objectID,
            category: item.building_system_name,
            projectName: item.name,
            projectImage: item.map_image,
            projectUnclaimed: item.is_unclaimed,
            projectSlug: item.slug,
        },
        geometry: {
            type: "Point",
            coordinates: [
                parseFloat(item._geoloc.lng),
                parseFloat(item._geoloc.lat)
            ]
        }
    }));

    const {clusters, supercluster} = useSupercluster({
        points,
        bounds,
        zoom,
        options: {radius: 50, maxZoom: 5, minPoints: 1}
    });


    let closeAllProjectView = () => {
        setSelectedUnclaimedProject(null);
        setSelectedProject(null);

        let marker_states = document.querySelectorAll('.win-marker-item');
        marker_states.forEach(function (m_state) {
            m_state.classList.remove('m-active');
            let img = m_state.dataset.img;
            m_state.src = img;
        });

    }

    let setProjectView = (project) => {
        closeAllProjectView();
        setSelectedProject(project);
        //console.log('project.project', project);
    }

    let setUnclaimedProjectView = (project) => {
        closeAllProjectView();
        setSelectedUnclaimedProject(project);
        //console.log('project.project', project);
    }


    const handleButtonClick = () => {
        //const url = 'https://www.woodworks.org/project-assistance-map/?utm_source=website&utm_medium=WIN_website&utm_campaign=project-assistance-map-link';
        const url = window.win_project_support_redirect;
        window.open(url, '_blank');
    }

    useEffect(
        () => {
            initAutocomplete();
            initMapLocation();
        },
        []
    );

    const defaultMapOptions = {
        fullscreenControl: false,
        hide: [
            {
                featureType: "poi.business",
                stylers: [{visibility: "off"}],
            },
            {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{visibility: "off"}],
            },
        ],
        //gestureHandling: "greedy",
    };

    return (
        <div style={{height: "100%", width: "100%"}}>
            <GoogleMapReact
                bootstrapURLKeys={{key: 'AIzaSyBU7bvKNaOiZ1pWaWsrlsmRF345jCPZJXI'}}
                defaultCenter={{lat: 38.6270, lng: -90.20}}
                center={{lat: mlat, lng: mlng}}
                options={defaultMapOptions}
                defaultZoom={10}
                zoom={zoom}
                hoverDistance={20}
                //markerHoverDistance={40}
                distanceToMouse={_distanceToMouse}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({map}) => {
                    mapRef.current = map;
                }}
                onChange={({zoom, bounds, marginBounds}) => {
                    let northEastLng = bounds.ne.lng < -180 ? 180 - ((bounds.ne.lng * -1) - 180) : bounds.ne.lng;
                    let southWestLng = bounds.sw.lng < -180 ? 180 - ((bounds.sw.lng * -1) - 180) : bounds.sw.lng;

                    let northWestLng = bounds.nw.lng < -180 ? 180 - ((bounds.nw.lng * -1) - 180) : bounds.nw.lng;
                    let southEastLng = bounds.se.lng < -180 ? 180 - ((bounds.se.lng * -1) - 180) : bounds.se.lng;

                    //console.log('onChangeBounds', bounds);
                    //console.log('onChangeMarginBounds', marginBounds);
                    setZoom(zoom);
                    setBounds([
                        northWestLng,
                        bounds.se.lat,
                        southEastLng,
                        bounds.nw.lat
                    ]);
                    refine({
                        northEast: {lat: bounds.ne.lat, lng: northEastLng},
                        southWest: {lat: bounds.sw.lat, lng: southWestLng},
                    });
                    localStorage.setItem(KEY_MAPZOOM, JSON.stringify(zoom));
                }}
                onChildMouseEnter={(key, childProps) => {
                    console.log('childProps', childProps)
                    if (childProps.id && childProps.projectUnclaimed !== true) {
                        let el = '#project-list-' + childProps.id;
                        if (document.querySelector(el)) {
                            document.querySelector(el).classList.add('project--inline_hover');
                        }
                    }
                }}
                onChildMouseLeave={(key, childProps) => {
                    if (childProps.id && childProps.projectUnclaimed !== true) {
                        let el = '#project-list-' + childProps.id;
                        if (document.querySelector(el)) {
                            document.querySelector(el).classList.remove('project--inline_hover');
                        }
                    }
                }}
                onChildClick={(key, childProps) => {
                    if (childProps.id) {
                        if (childProps.projectUnclaimed !== true) {
                            setProjectView(childProps);
                            let el = document.getElementById('marker-item-' + childProps.id);
                            if (el) {
                                //console.log('el', el);
                                el.classList.add('m-active');
                                let img = el.dataset.hover;
                                el.src = img;
                                //setTimeout(() => { el.src = img; }, 500);
                            }
                        } else {
                            setUnclaimedProjectView(childProps);
                        }
                    }
                }}
            >
                {clusters.map(cluster => {
                    const [longitude, latitude] = cluster.geometry.coordinates;
                    const {
                        cluster: isCluster,
                        point_count: pointCount,
                        category: category,
                    } = cluster.properties;

                    let markerCategory = cluster.properties.category === 'Mass Timber' ? MarkerMassTimber : MarkerLightFrame
                    let markerCategoryHover = cluster.properties.category === 'Mass Timber' ? MarkerMassTimberHover : MarkerLightFrameHover


                    if (cluster.properties.projectUnclaimed === true) {
                        markerCategory = MarkerMastTimberUnclaimed;
                        markerCategoryHover = MarkerMastTimberUnclaimedHover;
                    }

                    if (isCluster) {
                        return (
                            <ClusterMarker
                                key={`cluster-${cluster.id}`}
                                lat={latitude}
                                lng={longitude}
                            >
                                <div
                                    className="cluster-marker"
                                    style={{
                                        width: `${10 + (pointCount / points.length) * 20}px`,
                                        height: `${10 + (pointCount / points.length) * 20}px`
                                    }}
                                    onClick={() => {
                                        const expansionZoom = Math.min(
                                            supercluster.getClusterExpansionZoom(cluster.id),
                                            20
                                        );
                                        mapRef.current.setZoom(expansionZoom);
                                        mapRef.current.panTo({lat: latitude, lng: longitude});
                                    }}
                                >
                                    {pointCount}
                                </div>
                            </ClusterMarker>
                        );
                    }

                    return (

                        <Marker
                            key={`marker-item-${cluster.properties.id}`}
                            lat={latitude}
                            lng={longitude}
                            id={cluster.properties.id}
                            category={cluster.properties.category}
                            projectSlug={cluster.properties.projectSlug}
                            projectName={cluster.properties.projectName}
                            projectImage={cluster.properties.projectImage}
                            markerCategory={markerCategory}
                            markerCategoryHover={markerCategoryHover}
                            handleProjectViewClose={closeAllProjectView}
                            projectUnclaimed={cluster.properties.projectUnclaimed}
                            defaultScale={1}
                            hoveredScale={1}
                            stiffness={420}
                            damping={7}
                            precision={0.05}
                            on
                        >
                        </Marker>

                    );
                })}
            </GoogleMapReact>
            <ProjectHelpButton onClick={handleButtonClick}>
                {t('ProjectMapResource.Label')} <img src={ProjectLinkIcon} style={{paddingLeft: '9px'}}/>
            </ProjectHelpButton>
            <MapProjectView project={selectedProject}/>
            <MapProjectUnclaimedView project={selectedUnclaimedProject}/>
        </div>
    );

};


const ProjectMapPanel = connectGeoSearch(GeoSearch);
export default ProjectMapPanel
